import React, { useState } from 'react';
import styled from 'styled-components';
import axios from '../../services/axios';
import { useThemeContext } from '../../context/ThemeContext';

const Form = styled.form`
  display: ${({ $compact }) => ($compact ? 'flex' : 'block')};
  gap: 8px;
  margin-top: 10px;
  align-items: ${({ $compact }) => ($compact ? 'center' : 'initial')};
`;

const Input = styled.textarea`
  flex: 1;
  padding: 8px;
  border: 1px solid ${({ theme }) => theme.inputBorder || '#ccc'};
  border-radius: 6px;
  font-size: 0.95rem;
  resize: ${({ $compact }) => ($compact ? 'none' : 'vertical')};
  height: ${({ $compact }) => ($compact ? '34px' : '80px')};
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
`;

const Button = styled.button`
  margin-top: ${({ $compact }) => ($compact ? '0' : '6px')};
  padding: 6px 12px;
  background-color: ${({ theme }) => theme.primary || '#007bff'};
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
`;

const CommentForm = ({ postId, onSuccess, compact = false }) => {
  const [content, setContent] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { theme } = useThemeContext();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!content.trim()) return;

    setSubmitting(true);
    try {
      await axios.post('/api/comments/', { post: postId, content });
      setContent('');
      onSuccess?.();
    } catch (err) {
      console.error('Failed to submit comment:', err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit} $compact={compact} theme={theme}>
      <Input
        theme={theme}
        $compact={compact}
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder="Write a comment..."
        required
      />
      <Button type="submit" $compact={compact} theme={theme} disabled={submitting}>
        {submitting ? 'Posting...' : 'Post Comment'}
      </Button>
    </Form>
  );
};

export default CommentForm;
